<template>
  <div id="potential" class="x-wrapper mb-4">
    <div class="h1 fw-bold mb-3">
      ↓ Recevez gratuitement votre étude de potentiel
    </div>

    <div class="potential-blocks">
      <div class="block">
        <div class="block-title">Droits à construire</div>

        <table class="block-table">
          <tr>
            <td class="block-key">Extension/Surface neuve</td>
            <td class="block-value ta-right fw-bold">
              <span class="blur">XX</span>&nbsp;m²
            </td>
          </tr>
          <tr>
            <td class="block-key">Surélévation</td>
            <td class="block-value ta-right fw-bold">
              <span class="blur">XX</span>&nbsp;m²
            </td>
          </tr>
          <tr class="fz-medium">
            <td class="block-key">
              <b>Total</b>
            </td>
            <td class="block-value ta-right fw-bold">
              <span class="blur">XX</span>&nbsp;m²
            </td>
          </tr>
        </table>
      </div>
      <div class="block">
        <div class="block-title">Revenus immobiliers potentiels</div>
        <div class="table-flex">
          <table class="block-table">
            <tr>
              <td class="block-key">Commune</td>
              <td colspan="3" class="block-value h4 ta-left">
                {{ getUserAddressCity }}
              </td>
            </tr>
            <tr>
              <td class="block-key">Location (prix moyen)</td>
              <td class="block-value ta-right">
                <span class="blur">XX</span>&nbsp;€/m²
              </td>
              <td class="hide-on-mobile">
                <b>Total Location</b>
              </td>
              <td class="ta-right hide-on-mobile fz-medium">
                <span class="blur">X XXX</span>&nbsp;€/mois
              </td>
            </tr>
            <tr>
              <td class="block-key">Vente (prix moyen)</td>
              <td class="block-value ta-right">
                <span class="blur">X XXX</span>&nbsp;€/m²
              </td>
              <td class="hide-on-mobile">
                <b>Total Vente</b>
              </td>
              <td class="ta-right hide-on-mobile fz-medium">
                <span class="blur">X XXX XXX</span>&nbsp;€
              </td>
            </tr>
          </table>
          <table class="block-table hide-on-desktop">
            <tr>
              <td>
                <b>Total Location</b>
              </td>
              <td class="ta-right fz-medium">
                <span class="blur">X XXX</span>&nbsp;€/mois
              </td>
            </tr>
            <tr>
              <td>
                <b>Total Vente</b>
              </td>
              <td class="ta-right fz-medium">
                <span class="blur">X XXX XXX</span>&nbsp;€
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- <SvgLandUnit :parcels="getUserParcels" /> -->
  </div>
</template>

<script>
import { defineComponent, onMounted } from "@vue/composition-api";
// import SvgLandUnit from "./SvgLandUnit.vue";
import Block from "./Block.vue";
import { useUtils, useCheckout } from "@front/store";
import { useUser } from "@front/store/user";
import { updateRouteLocation } from "@front/router";

export default defineComponent({
  components: {
    Block,
    // SvgLandUnit,
  },
  setup() {
    onMounted(() => {
      // if (getRouteStep.value === ScrollIds.POTENTIAL) {
      // scrollToElement(`#${ScrollIds.POTENTIAL}`, {
      //   block: "start",
      // });
      // }
    });

    return {
      ...useUser(),
      ...useUtils(),
      ...useCheckout(),
      updateRouteLocation,
    };
  },
});
</script>

<style lang="scss">
@import "../scss/the-potential";
</style>
